import { gql } from '@apollo/client'

import { INVOICE_FIELDS } from '../fragments/invoice'

export const FETCH_INVOICE = (includeRetailOrderLineItems: boolean) => gql`
  ${INVOICE_FIELDS(includeRetailOrderLineItems)}
  query FetchInvoice($businessId: ID, $id: ID!, $includeDeleted: Boolean) {
    invoice(businessId: $businessId, id: $id, includeDeleted: $includeDeleted) {
      ...InvoiceFields
      serviceFee
      paid
    }
  }
`
